import React, { useState } from "react";
import GeuModal from "./GeuModal";
import "../../styles/feeStructure.css";

export default function FeeStructureSection({ college }) {
  const [geuModalOpen, setGeuModalOpen] = useState(false);

  // ✅ Check for cdbrochure instead of brochure
  if (!college?.cdbrochure && college?.slug !== 'graphic-era-dehradun') {
    return null; // Don't show anything if no PDF and not Graphic Era
  }

  const handleClick = (e) => {
    e.preventDefault();
    
    // Check if this is Graphic Era
    if (college.slug === 'graphic-era-dehradun') {
      setGeuModalOpen(true);
    } else {
      // For other colleges, open PDF directly
      window.open(college.cdbrochure, '_blank', 'noopener,noreferrer');
    }
  };

  return (
    <section className="fee-structure-section">
      <div className="fee-structure-container">
        <h2 className="fee-structure-title">Fee Structure</h2>

        <button 
          onClick={handleClick}
          className="fee-structure-btn"
        >
          View Fee Structure
        </button>

        {/* GeuModal */}
        <GeuModal 
          isOpen={geuModalOpen}
          onClose={() => setGeuModalOpen(false)}
          college={college}
        />
      </div>
    </section>
  );
}
